import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { startLiveAnswerRequested } from 'features/qa/actions';

export function* startLiveAnswerSaga(action: ReturnType<typeof startLiveAnswerRequested>) {
  yield call(SignalingSocket.send, {
    event: 'startLiveAnswerQuestion',
    data: {
      questionId: action.payload,
    },
  });
}
